export default __webpack_public_path__ + "static/media/IMG_2179cropped.245128d6.jpeg";